module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAOCAYAAAAIar0YAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAABkSURBVAiZvcuxDYJgFADh771YUzmEozCGg2BC4R4WjmCIJYWtxhUYAqzA30YaB/DKu1z4cr+028zlltD37SZzOWOXUL3mBjXEo2vqENd1TSWOGDBDrOXZHU6Fffrhz+KtTML4AUzvGMifZpvDAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/px1_act.png
// module id = L9vh
// module chunks = 1